<template>
  <div style="display: flex;">

    <div class="btn btn-info" @click="showModal = true">
      <i class="fas fa-file"></i>
    </div>

    <b-modal v-model="showModal" :hideFooter="true" size="md" title="Generate invoice">

      <div class="form-group">

        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">DTR</span>
          </div>
          <input type="number" class="form-control text-center" v-model="invoiceNumber" :disabled="generating" placeholder="Next invoice number">
        </div>
      </div>
      <div class="form-group">
        <date-picker
          class="text-center"
          @dateSelected="invoiceDate = $event"
          :dateFormat="'dd M yyyy'"
          :defaultDate="invoiceDate"
          @blur="$v.invoiceDate.$touch()"></date-picker>
      </div>

      <div class="form-group" v-if="client.currency_id === 2">
        <label>GBP</label>
        <input type="number" class="form-control" v-model="exchangeRate">
      </div>
      <div class="form-group" v-if="client.currency_id === 3">
        <label>USD</label>
        <input type="number" class="form-control" v-model="exchangeRate">
      </div>
      <div class="form-group" v-if="client.currency_id === 4">
        <label>AUD</label>
        <input type="number" class="form-control" v-model="exchangeRate">
      </div>

      <div class="mb-3">
        <span class="btn btn-sm btn-info" @click="showProjects = !showProjects">{{ showProjects ? 'Hide' : 'Show' }} projects</span>
      </div>

      <div class="clients" v-show="showProjects">
        <project-groups :projects="projects"></project-groups>
      </div>

      <div class="form-group" style="text-align:center;">
        <button class="btn btn-success" @click="generate()" v-if="!generating" :disabled="!invoiceNumber">Generate</button>
        <button class="btn btn-success" v-if="generating" :disabled="true">
          <i class="fa fa-sync fa-spin"></i>
        </button>
      </div>

    </b-modal>

  </div>
</template>
<script>
  import bModal from 'bootstrap-vue/src/components/modal/modal'
  import DatePicker from '../../components/partials/Datepicker.vue'
  import ProjectGroups from './ProjectGroups.vue'

  export default {
    props: ['projects', 'client', 'startDate', 'endDate'],
    components: {
      'b-modal': bModal,
      'date-picker': DatePicker,
      ProjectGroups,
    },
    created() {
      this.invoiceDate = moment(this.endDate).format('DD MMM YYYY')

      if (this.client.invoices && this.client.invoices.length > 0) {
        let i = _.first(_.sortBy(this.client.invoices, 'id'))
        this.invoiceNumber = i.number_raw
      }
    },
    data() {
      return {
        generating: false,
        exchangeRate: null,
        invoiceDate: null,
        invoiceNumber: null,
        showProjects: false,
        showModal: false,
      }
    },
    methods: {
      generate() {
        this.generating = true

        let exchangeRates = {}
        exchangeRates[this.client.currency_id] = this.exchangeRate

        this.axios.post('clients/invoice', {
          startDate: this.startDate,
          endDate: this.endDate,
          exchangeRates: exchangeRates,
          invoiceNumber: this.invoiceNumber,
          invoiceDate:
          this.invoiceDate,
          clients:
            [this.client.id]
        }).then(response => {
          this.$emit('invoiced')
        }).catch(err => {
          this.$awn.alert('Failed to generate invoice.')
        }).finally(() => {
          this.generating = false
        })
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/views/financialReports/ClientInvoiceButton.vue